module.exports = __webpack_public_path__ + "cm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cm.svg
// module id = 496
// module chunks = 0